import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";

const MeetingItem = ({
  selectedItemData,
  infoRefresh,
  inviteAction,
  listType,
}) => {
  const current_day = moment().format("MMM DD");
  const state = useSelector((state) => state.UserReducer);

  const inviteStatusBadge = (status) => {
    switch (status) {
      case "Rejected":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-medium mt-0.5 px-1.5 py-0.5 rounded'>
            Rejected
          </span>
        );
      case "Accepted":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-medium mt-0.5 px-1.5 py-0.5 rounded'>
            Accepted
          </span>
        );
      default:
        return (
          <span className='bg-gray-100 text-gray-800 text-xs font-medium mt-0.5 px-1.5 py-0.5 rounded '>
            Not Responded
          </span>
        );
    }
  };

  return (
    <>
      {!selectedItemData._id ? (
        <div className='px-4 py-6 sm:px-0 flex justify-center bg-gray-50 w-full xl:w-10/12 '>
          <div className='flex flex-col space-y-2 py-40'>
            <img
              src='/assets/images/select_from_list.svg'
              className='w-64'
              alt='select_item'
            />
            <h2 className='mt-10 text-center text-base font-base leading-0 text-gray-dark sm:text-xl '>
              Select an item to view details
            </h2>
          </div>
        </div>
      ) : !infoRefresh ? (
        <div className='flex flex-col space-y-3 py-3 pb-5 px-2'>
          <span className='text-lg font-medium text-gray-dark'>
            Meeting Info
          </span>
          <div className='grid grid-cols-3 gap-3'>
            <div className='col-span-2'>
              <div className='flex flex-col space-y-0'>
                <span className='text-sm font-medium text-yellow-dark'>
                  Topic
                </span>
                <span className='text-base font-medium text-gray-700'>
                  {selectedItemData.topic}
                </span>
              </div>
            </div>
            <div className=''>
              <div className='flex flex-col space-y-0'>
                <span className='text-sm font-medium text-yellow-dark'>
                  Location
                </span>
                <span className='text-base font-medium text-gray-700'>
                  {selectedItemData.location}
                </span>
              </div>
            </div>
          </div>
          <div className='grid grid-cols-3 gap-3'>
            <div className='col-span-2'>
              <div className='flex flex-col space-y-0'>
                <span className='text-sm font-medium text-yellow-dark'>
                  Happening By
                </span>
                <span className='text-base font-medium text-gray-700'>
                  {(selectedItemData.recurring
                    ? "Recurring, "
                    : moment(selectedItemData.from_time).format("MMM DD") ===
                      current_day
                    ? "Today, "
                    : moment(selectedItemData.from_time).format("MMM DD, ")) +
                    moment(selectedItemData.from_time).format("hh:mmA")}
                  {" - "}
                  {moment(selectedItemData.from_time).format("MMM DD") ===
                  moment(selectedItemData.till_time).format("MMM DD")
                    ? moment(selectedItemData.till_time).format("hh:mmA")
                    : moment(selectedItemData.till_time).format(
                        "MMM DD, hh:mmA",
                      )}{" "}
                  {selectedItemData.recurring === true &&
                    "(till " +
                      moment(selectedItemData.recurring_till_date).format(
                        "DD MMM yyyy",
                      ) +
                      ")"}
                </span>
              </div>
            </div>
          </div>
          <div className='grid grid-cols-3 gap-2'>
            <div className='col-span-2 flex flex-col space-y-1'>
              <span className='text-sm font-medium text-yellow-dark'>
                Attendees
              </span>
              <div className='flex flex-col justify-center space-y-2'>
                {selectedItemData.attendeesRequired.map((item) => (
                  <div
                    key={item._id}
                    className='bg-yellow-50 py-1.5 px-2 rounded-sm flex flex-nowrap justify-center w-fit gap-2 hover:bg-yellow-100 duration-300 cursor-default'>
                    <img
                      src={
                        item.user?.avatar
                          ? item.user?.avatar
                          : "/assets/images/user.png"
                      }
                      alt='avatar'
                      referrerPolicy='no-referrer'
                      className=' h-6 w-6 rounded-full ring-1 ring-yellow-2'
                    />
                    <span className='font-medium text-sm text-yellow-dark mt-0.5'>
                      {item.user?.fullname
                        ? item.user.fullname
                        : item.user.firstname}{" "}
                      | {item.user.email}
                    </span>
                    {inviteStatusBadge(item.response)}
                  </div>
                ))}
              </div>
            </div>
            <div className='flex flex-col space-y-4'>
              <div className='flex flex-col space-y-0'>
                <span className='text-sm font-medium text-yellow-dark'>
                  Organizer
                </span>
                <div className='bg-yellow-100 py-1.5 px-2 rounded-sm flex flex-nowrap justify-center w-fit gap-2 hover:bg-yellow-50 duration-300 cursor-default'>
                  <img
                    src={
                      selectedItemData.organizedBy?.avatar
                        ? selectedItemData.organizedBy?.avatar
                        : "/assets/images/user.png"
                    }
                    alt='avatar'
                    referrerPolicy='no-referrer'
                    className=' h-6 w-6 rounded-full ring-1 ring-yellow-2'
                  />
                  <span className='font-medium text-sm text-yellow-dark mt-0.5'>
                    {selectedItemData.organizedBy?.fullname
                      ? selectedItemData.organizedBy.fullname
                      : selectedItemData.organizedBy.firstname}
                  </span>
                </div>
              </div>
              <div className='flex flex-col space-y-0'>
                <span className='text-sm font-medium text-yellow-dark'>
                  Notes Taker
                </span>
                <div className='bg-yellow-100 py-1.5 px-2 rounded-sm flex flex-nowrap justify-center w-fit gap-2 hover:bg-yellow-50 duration-300 cursor-default'>
                  <img
                    src={
                      selectedItemData.notesTaker?.avatar
                        ? selectedItemData.notesTaker?.avatar
                        : "/assets/images/user.png"
                    }
                    alt='avatar'
                    referrerPolicy='no-referrer'
                    className=' h-6 w-6 rounded-full ring-1 ring-yellow-2'
                  />
                  <span className='font-medium text-sm text-yellow-dark mt-0.5'>
                    {selectedItemData.notesTaker?.fullname
                      ? selectedItemData.notesTaker.fullname
                      : selectedItemData.notesTaker.firstname}
                  </span>
                </div>
              </div>
              <div className='flex flex-col space-y-0'>
                <span className='text-sm font-medium text-yellow-dark'>
                  Time Keeper
                </span>
                <div className='bg-yellow-100 py-1.5 px-2 rounded-sm flex flex-nowrap justify-center w-fit gap-2 hover:bg-yellow-50 duration-300 cursor-default'>
                  <img
                    src={
                      selectedItemData.timeKeeper?.avatar
                        ? selectedItemData.timeKeeper?.avatar
                        : "/assets/images/user.png"
                    }
                    alt='avatar'
                    referrerPolicy='no-referrer'
                    className=' h-6 w-6 rounded-full ring-1 ring-yellow-2'
                  />
                  <span className='font-medium text-sm text-yellow-dark mt-0.5'>
                    {selectedItemData.timeKeeper?.fullname
                      ? selectedItemData.timeKeeper.fullname
                      : selectedItemData.timeKeeper.firstname}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='w-full border-0 pt-4'>
            <div className='flex flex-col space-y-6'>
              <div className='flex flex-col space-y-0'>
                <span className='text-sm font-medium text-yellow-dark'>
                  Agenda
                </span>
                <div
                  className=''
                  dangerouslySetInnerHTML={{
                    __html: selectedItemData.agenda,
                  }}></div>
              </div>
              {selectedItemData.validflag === 3 && (
                <div className='flex flex-col space-y-0'>
                  <span className='text-sm font-medium text-yellow-dark'>
                    Minutes Of Meeting
                  </span>
                  <div
                    className=''
                    dangerouslySetInnerHTML={{
                      __html: selectedItemData.minutesOfMeeting,
                    }}></div>
                </div>
              )}
            </div>
          </div>
          {selectedItemData.notesTaker._id !== state.user._id &&
            selectedItemData.timeKeeper._id !== state.user._id &&
            selectedItemData.organizedBy._id !== state.user._id &&
            listType === "now" && (
              <div className='flex justify-end space-x-2'>
                <span
                  className='bg-green-100 text-green-800 text-base font-medium mr-2 px-2.5 py-0.5 rounded duration-300 border-2 border-green-100 hover:border-green-800 cursor-pointer'
                  onClick={(event) => {
                    inviteAction("Accepted", selectedItemData._id);
                  }}>
                  Accept Invite
                </span>
                <span
                  className='bg-red-100 text-red-800 text-base font-medium mr-2 px-2.5 py-0.5 rounded duration-300 border-2 border-red-100 hover:border-red-800 cursor-pointer'
                  onClick={(event) => {
                    inviteAction("Rejected", selectedItemData._id);
                  }}>
                  Reject Invite
                </span>
              </div>
            )}
        </div>
      ) : (
        <div className='grid grid-cols-4 gap-4 py-2 px-1'>
          <div className='col-span-1 flex flex-col space-y-2 p-1 opacity-75'>
            <div className='flex flex-col px-2 py-3 space-y-2 rounded-sm items-left animate-pulse duration-100 justify-center bg-gray-100'>
              <div className='flex flex-row gap-2'>
                <div className='w-full bg-yellow-3 h-6 rounded-sm '></div>
              </div>
              <div className='flex flex-nowrap space-x-3'>
                <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
                <div className='w-full bg-gray-200 h-4 rounded-sm '></div>
              </div>
              <div className='flex flex-row space-x-3'>
                <div className='w-8/12 bg-gray-200 h-5 rounded-sm '></div>
                <div className='w-4/12 bg-yellow-2 h-5 rounded-sm '></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MeetingItem;
